import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    number: number;
}

const SupervisorOpenQueuesNumber = ({ number }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="box-border flex h-10 w-fit items-center justify-center rounded-sm border bg-white text-base dark:bg-gray-100">
            <div className="flex h-full flex-2 items-center justify-center px-3">
                {i18next.t('pbx.open')}
            </div>
            <span className="flex h-full items-center border-s px-3 font-bold">
                {number}
            </span>
        </div>
    );
};

export default React.memo(SupervisorOpenQueuesNumber);
